import { PostCardListFragment, PrevNextArticleFragment } from 'gql/graphql-operations';
import React from 'react';
import twMerge from 'utilities/src/twMerge';
import PostCardsList from './PostCardList';

type PrevNextArticlesProps = {
  previousArticle: PrevNextArticleFragment | null;
  nextArticle: PrevNextArticleFragment | null;
};

export default function PrevNextArticles({ nextArticle, previousArticle }: PrevNextArticlesProps) {
  const articles = [previousArticle, nextArticle];

  return (
    <div className="relative pt-14">
      <section>
        <PostCardsList
          classes={twMerge('grid-cols-2 mdL:grid-cols-2', {
            '[&_div]:col-span-2 [&_div]:md:col-end-3 [&_div]:md:col-span-1': !!nextArticle && !previousArticle,
            '[&_div]:col-span-2 [&_div]:md:col-span-1': !nextArticle && !!previousArticle,
          })}
          posts={articles as PostCardListFragment[] | null[]}
          isFullImage
        />
      </section>
    </div>
  );
}
